import React from "react";

const IcCheckBlue = (props) => {
  return (
    <svg
        {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 4.5L6.75 12.75L3 9"
        stroke="#33ADFF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IcCheckBlue;
